import {createAction, handleActions} from 'redux-actions';

const FETCH = '@nezzokontikifrontend/Teaser/FETCH';
const COUNT = '@nezzokontikifrontend/Teaser/COUNT';
const FETCH_FAILED = '@nezzokontikifrontend/Teaser/FETCH_FAILED';
const SET = '@nezzokontikifrontend/Teaser/SET';
const ADD = '@nezzokontikifrontend/Teaser/ADD';

export const actionTypes = {
	FETCH,
	COUNT,
	FETCH_FAILED,
	SET,
	ADD
};

const fetch = createAction(FETCH);

const count = createAction(COUNT, count => count);

const fetchFailed = createAction(FETCH_FAILED, message => message);

const set = createAction(SET, teasers => teasers);

const add = createAction(ADD, teasers => teasers);

export const actions = {
	fetch,
	count,
	fetchFailed,
	set,
	add
};

const defaultState = {
	teasers: [],
	errors: [],
	count: 0
};

export const reducer = handleActions({
	[FETCH]: state => {
		return {...state};
	},
	[COUNT]: (state, action) => {
		return {...state, count: action.payload}
	},
	[FETCH_FAILED]: (state, action) => {
		return {...state, teasers: [], errors: state.errors.concat(action.payload.message)};
	},
	[SET]: (state, action) => {
		return {...state, teasers: action.payload.data};
	},
	[ADD]: (state, action) => {
		return {...state, teasers: state.teasers.concat(action.payload.data)}
	}
}, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/teaser.js